import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {IdSharedValueObject} from '../../shared/ValueObjects/IdSharedValueObject.js'

export class TaxPriceValueObject extends ValueObject {
  #hasTaxes
  #id
  #name

  constructor({hasTaxes, id, name}) {
    super()
    this.#hasTaxes = hasTaxes
    this.#id = id
    this.#name = name
  }

  static createFromListingApi({hasTaxes, taxTypeId}) {
    const {TAXES} = ConfigContext.get('COMMON')

    return new TaxPriceValueObject({
      hasTaxes,
      id: taxTypeId ? IdSharedValueObject.createFromPrimitives({id: taxTypeId}) : {},
      name: TAXES.TAXES_BY_ID[taxTypeId]?.name
    })
  }

  get hasTaxes() {
    return this.#hasTaxes
  }

  get id() {
    return this.#id.value
  }

  get name() {
    return this.#name
  }

  get value() {
    return {hasTaxes: this.hasTaxes, id: this.id, name: this.name}
  }
}
